/**
 * Prefix hex-looking input with "#", without expanding partial values while the user types.
 */
export function prefixHexColor(input: string): string {
  const val = input.trim();
  if (!val || val.startsWith('#')) return val;
  return /^[0-9a-fA-F]{1,8}$/.test(val) ? `#${val}` : val;
}

/**
 * Normalize a hex color string:
 * - Auto-prepend '#' if missing
 * - Expand 3-char shorthand: '666' -> '#666666', 'f0a' -> '#ff00aa'
 */
export function normalizeHexColor(input: string): string {
  const val = prefixHexColor(input);
  if (!val) return val;

  const raw = val.startsWith('#') ? val.slice(1) : val;

  if (/^[0-9a-fA-F]{3}$/.test(raw)) {
    const expanded = raw[0] + raw[0] + raw[1] + raw[1] + raw[2] + raw[2];
    return `#${expanded}`;
  }

  if (/^[0-9a-fA-F]{6}$/.test(raw)) {
    return `#${raw}`;
  }

  return val;
}

/**
 * Ensure color is valid for <input type="color"> (requires #rrggbb).
 */
export function safeColorForPicker(value: string | null | undefined, fallback = '#000000'): string {
  const normalizedFallback = normalizeHexColor(fallback);
  const safeFallback = /^#[0-9a-fA-F]{6}$/.test(normalizedFallback) ? normalizedFallback : '#000000';
  if (!value) return safeFallback;
  const normalized = normalizeHexColor(value);
  return /^#[0-9a-fA-F]{6}$/.test(normalized) ? normalized : safeFallback;
}
